import ColorPopupProvider from "./ColorPopupProvider";
import ContextPadProvider from "./ContextPadProvider";
import CustomPaletteProvider from "./CustomPaletteProvider";
import RestrictTransformationProvider from "./RestrictTransformationProvider";
import BpmnSearchProvider from "./BpmnSearchProvider";

export default {
  __init__: [
    "paletteProvider",
    "colorPopupProvider",
    "contextPadProvider",
    "restrictTransformationProvider",
    "bpmnSearch"
  ],
  paletteProvider: ["type", CustomPaletteProvider],
  contextPadProvider: ["type", ContextPadProvider],
  colorPopupProvider: ["type", ColorPopupProvider],
  restrictTransformationProvider: ["type", RestrictTransformationProvider],
  bpmnSearch: [ "type", BpmnSearchProvider ]
};
